export function escapeCSVValue(value: unknown): string {
  if (value === null || value === undefined) return '';
  let str = String(value);

  if (/^[=+\-@\t\r]/.test(str)) {
    str = "'" + str;
  }

  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}
